var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eu-display_flex eu-align-items_center eu-width_100" },
    [
      _c(
        "div",
        { staticClass: "emd-form-group eu-pt_3 eu-pb_2 eu-width_100" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.copiable,
                expression: "copiable",
              },
            ],
            staticClass: "emd-input",
            attrs: { disabled: "", type: "text" },
            domProps: { value: _vm.copiable },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.copiable = $event.target.value
              },
            },
          }),
        ]
      ),
      !_vm.viewCopy
        ? _c("div", { staticClass: "emd-tip _hoverble eu-mx_1" }, [
            _c("div", { staticClass: "emd-tip__container" }, [
              _c(
                "div",
                {
                  staticClass:
                    "emd-tip__box _color_contrast _arrow_top _position_bottom _no_shadow eu-mt_2 eu-ml_2",
                },
                [_vm._v(" " + _vm._s(_vm.label) + " ")]
              ),
            ]),
            _c(
              "button",
              {
                staticClass: "emd-action-button header-button",
                on: { click: _vm.handleClicked },
              },
              [
                _c("emerald-icon", {
                  attrs: { icon: "copy", "data-testid": "button-copy" },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }